import React from "react";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box"

export interface SelectableTextProps {
    textSelected: boolean,
    textVal: string,
}

const SelectableText = (props: SelectableTextProps) => {
    let { textSelected, textVal } = props;

    if (textSelected) {
        return (<>
            <Box
                component={Typography}
                variant="body2"
                sx={{ textDecoration: "underline" }}
            >
                {textVal}
            </Box>
        </>)
    }

    return (<>
        <Box
            component={Typography}
            variant="body2"
        >
            {textVal}
        </Box>
    </>)
}

export default SelectableText